// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GridWrapper_wrapper__KSsOO","container":"GridWrapper_container__qqCsH","default":"GridWrapper_default__TqB3L","aside":"GridWrapper_aside__TpFPi"};